export default __webpack_public_path__ + "static/media/illustrativeWebsite.68236f7c.svg";